<template>
    <div class="infor-content">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('privacyPolicy.title')}}
                <hr>
            </span>
        </h1>
        <!-- CookiePolicy -->
        <div class="row info-row">
            <h1>{{$t('privacyPolicy.A.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.A.textItem')" v-html="item"></p>
            <p><strong>{{$t('privacyPolicy.A.scope.title')}}</strong></p>
            <p v-for="item in $t('privacyPolicy.A.scope.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.B.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.B.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.C.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.C.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.D.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.D.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.E.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.E.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.F.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.F.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.G.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.G.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.H.title')}}</h1>
            <p v-html="$t('privacyPolicy.H.textItem')"></p>
            <h1>{{$t('privacyPolicy.I.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.I.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.J.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.J.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.K.title')}}</h1>
            <p v-for="item in $t('privacyPolicy.K.textItem')" v-html="item"></p>
            <h1>{{$t('privacyPolicy.L.title')}}</h1>
            <p v-html="$t('privacyPolicy.L.textItem')"></p>
            <h1>{{$t('privacyPolicy.M.title')}}</h1>
            <p v-html="$t('privacyPolicy.M.textItem')"></p>
            <h1>{{$t('privacyPolicy.N.title')}}</h1>
            <p v-html="$t('privacyPolicy.N.textItem')"></p>
            <p v-html="$t('privacyPolicy.N.contact')" style="color:#29AAE1;"></p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
    .info-row h1{
        font-size: 3rem;
        font-weight: bold;
        color:#29AAE1;
        text-align: left;
        margin-bottom: 6rem;
        margin-top: 4rem;
        line-height: 1.5;
    }
    .info-row p{
        width:100% !important;
        text-align:left;
        margin:2rem 0;
    }
    @media (max-width: 767px){
        .info-row h1{
            font-size: 1rem;
            margin-bottom: 4rem;
            margin-left: 1rem;
            margin-bottom: 1rem;
            margin-top: 1rem;
        }
        .info-row p{
            margin:1rem 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Footer/PrivacyPolicy.vue